module.exports = __webpack_public_path__ + "static/media/peeps_grade.7efeba35.svg";